<template>
<div class="message">
    <div class="message-right-nav">
        <span>{{ $t('comb.messageCenter') }}</span>
    </div>
    <div class="message-right-list">
        <div class="message-item" v-for="message in messages">
            <div class="head-icon">
                <img src="http://static2.test.ximalaya.com/lib/a2/last/css/img/default/cat2.png?version=1482913369915">
            </div>
            <div class="content">
                <div class="content-top">
                    <span class="title">{{ message.subject }}</span>
                    <span class="messsage-date">{{ getFormatDate(new Date(message.createTime)) }}</span>
                </div>
                <div class="content-bottom" :class="{ 'unread': !message.isRead }" v-html="message.content">
                </div>
            </div>
        </div>
        <div style="display: flex; width: 100%; justify-content: flex-end;" v-if="totalPages>1">
            <div class="message-pagination">
                <el-pagination @current-change="getMessages" :page-count="totalPages" layout="prev, pager, next"></el-pagination>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import axios from 'axios';
import moment from 'moment';
export default {
    data() {
        return {
            pageSize: 10,
            pageIndex: 1,
            messageCount: 0,
            totalPages: 0,
            messages: []
        }
    },
    mounted() {
        this.getMessages(this.pageIndex);
    },
    methods: {
        getMessages(pageIndex) {
            const that = this;
            this.pageIndex = pageIndex;
            axios.get(`/api/message/type/-1/pagenum/${pageIndex}`).then(result => {
                if (result.data.code == 200) {
                    const res = result.data.data;
                    this.messageCount = res.total;
                    this.pageIndex = res.pageNum;
                    this.totalPages = res.pages;
                    this.messages = res.items;
                }
            }).catch(error => {
                this.$notify.error({
                    title: that.$i18n.t('word.error'),
                    message: error.message
                });
            });
        },
        getFormatDate(date) {
            return moment(date).format('YYYY-MM-DD');
        }
    },
    computed: {
        UPLOAD_IMG_HOST() {
            return this.$store.state.UPLOAD_IMG_HOST;
        }
    }
}
</script>
<style lang="sass" scoped>
    @import "../../../sass/copyright/center/messages.scss";
</style>



// WEBPACK FOOTER //
// Messages.vue?4e33307c